import { ExtranetOrderListItemDto } from '@pharmac-extranet/extranet-api'
import {
  ExtranetCatalogItemChevron,
  ExtranetExpandArrowColumn,
  ExtranetTableColumn,
  ExtranetTableGroupColumn,
  ExtranetTableRow,
  formatDateString,
  useBreakpoint,
  useLanguage,
} from '@pharmac-extranet/shared'
import { PharmacCheckbox, PharmacText } from '@pharmac/ui'
import { OrderHistoryCustomerGroupOrders } from './OrderHistoryCustomerGroupOrders'
import { useOrderCheckboxes } from './useOrderCheckboxes'

type OrderHistoryItemProps = {
  order: ExtranetOrderListItemDto
  hook: ReturnType<typeof useOrderCheckboxes>
}

export const OrderHistoryCustomerGroup = ({ order, hook }: OrderHistoryItemProps) => {
  const { minDesktop, maxMobile } = useBreakpoint()
  const { t } = useLanguage(['extranet'])

  const isChecked = hook.checkboxes[order.groupId + order.createdAt]?.length === order.orders.length

  const groupStatus = () => {
    if (order.orders.map((a) => a.status === 'arrived').includes(true))
      return t('orderHistory.status.arrived')
    if (order.orders.map((a) => a.status === 'missing-information').includes(true))
      return t('orderHistory.status.missing-information')
    if (order.orders.map((a) => a.status === 'in-manufacturing').includes(true))
      return t('orderHistory.status.in-manufacturing')
    if (order.orders.map((a) => a.status === 'sent').includes(true))
      return t('orderHistory.status.sent')

    return t('orderHistory.status.cancelled')
  }

  return (
    <ExtranetTableRow
      key={order?.groupId}
      expand={
        <OrderHistoryCustomerGroupOrders
          hook={hook}
          tableItem={order}
        />
      }
      toggleExpand={() => null}
      children={({ isExpanded }) => (
        <>
          <ExtranetTableGroupColumn>
            <ExtranetTableRow>
              {minDesktop && (
                <ExtranetTableColumn
                  onClick={(e) => e.stopPropagation()}
                  size={1}
                  marginSmallLeft
                >
                  <PharmacCheckbox
                    checked={isChecked}
                    handleChange={() =>
                      hook.toggleGroupCheckboxes(
                        order,
                        order.orders.map((a) => a.id)
                      )
                    }
                  />
                </ExtranetTableColumn>
              )}
              <ExtranetTableColumn
                size={maxMobile ? 2.5 : 1.5}
                style={{ fontWeight: 600 }}
              >
                {formatDateString(order?.createdAt)}
              </ExtranetTableColumn>
              <ExtranetTableColumn
                size={maxMobile ? 3 : 3.5}
                style={{ fontWeight: 600, overflow: 'auto' }}
              >
                {order?.groupName}
              </ExtranetTableColumn>
              <ExtranetTableColumn size={maxMobile ? 1 : 2}>
                {order?.ordersCount}
              </ExtranetTableColumn>
              {minDesktop && <ExtranetTableColumn size={2}>{groupStatus()}</ExtranetTableColumn>}
              <ExtranetExpandArrowColumn>
                <ExtranetCatalogItemChevron isExpanded={isExpanded} />
              </ExtranetExpandArrowColumn>
            </ExtranetTableRow>
            {!minDesktop && (
              <ExtranetTableRow
                noMargin
                noBorders
                style={{
                  borderTop: '2px dashed var(--color-accent-4)',
                }}
              >
                <ExtranetTableColumn size={3.5} />
                <ExtranetTableColumn size={13.5}>
                  <ExtranetTableRow
                    noBorders
                    noMargin
                  >
                    <PharmacText style={{ fontSize: '16px' }}>
                      {t('orderHistory.orderState')}:
                    </PharmacText>
                    <div style={{ width: 'var(--spacing-small)' }} />
                    <PharmacText
                      style={{ fontSize: '16px' }}
                      weight="bold"
                    >
                      {groupStatus()}
                    </PharmacText>
                  </ExtranetTableRow>
                </ExtranetTableColumn>
              </ExtranetTableRow>
            )}
          </ExtranetTableGroupColumn>
        </>
      )}
    />
  )
}
